/*
  The layout preference: how /y folds.

  The owner is trying two structures side by side on real data (surface brief,
  .impeccable/surfaces/src-pages-y.md): *One split sheet*, the base, and *Index &
  command*, a switchable layer over it (a finder bar above list and room, the rail
  as stepped room-colour tabs). This is the switch. The shell reads it through
  `useLayoutMode()` (pages/y/layout.tsx, ListSheetHeader); `data-layout` on <html>
  carries it for first paint.

  Persisted exactly like the theme (src/lib/themes.ts, hooks/use-theme.ts): a bare
  string in localStorage, applied to <html> before first paint by the boot script
  in index.html, which duplicates the list below because it runs before any module.
  layout-mode.test.ts fails if the two disagree.
*/

export const LAYOUT_MODES = ["split", "index"] as const;

export type LayoutMode = (typeof LAYOUT_MODES)[number];

export const DEFAULT_LAYOUT_MODE: LayoutMode = "split";

/* Duplicated as a literal in index.html's boot script. */
export const LAYOUT_STORAGE_KEY = "astring-layout";

export function isLayoutMode(value: unknown): value is LayoutMode {
  return typeof value === "string" && (LAYOUT_MODES as readonly string[]).includes(value);
}

/** A stored value made safe for the DOM: a known mode, or null for the caller's default. */
export function resolveLayoutMode(value: unknown): LayoutMode | null {
  return isLayoutMode(value) ? value : null;
}
